import { type IProjectRentalIntakeItem } from "@/interfaces/api/project-rental-intake-item.interface"
import { BaseRepository } from "@/repositories/base-repository"

export class ProjectRentalIntakeItemRepository extends BaseRepository<IProjectRentalIntakeItem> {
  protected resourcePath = "administration/projects-rental-intake-items"
}
